import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Spin, Modal } from 'antd'
import {withTranslation} from 'react-i18next'
import AddressSearchForm from './AddressSearchForm'
import AddressSearchResult from './AddressSearchResult'
const storage = window.localStorage
@inject('emailListStore')
@observer
class TemplateList extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
  }
  render() {
    const { emailListStore, addModalVisible, handleCancel, sourceType, isValid, t } = this.props
    const { isFetchingAddress } = emailListStore
    return (
      <Modal
        title='输入邮件详情'
        closable={true}
        visible={addModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={'60%'}
        centered
        footer={false}
        className='shortLinkModel'
      >
        <Spin spinning={isFetchingAddress}>
          <AddressSearchForm sourceType={sourceType} isValid={isValid} />
          <AddressSearchResult sourceType={sourceType} handleCancel={handleCancel} />
        </Spin>
      </Modal>
    )
  }
}

export default withTranslation()(TemplateList)
